"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmployee = createEmployee;
exports.getEmployeeList = getEmployeeList;
exports.getEmployee = getEmployee;
exports.updateEmployee = updateEmployee;
exports.deleteEmployee = deleteEmployee;
exports.updateEmployeeBranches = updateEmployeeBranches;
exports.createSpotShift = createSpotShift;
exports.editSpotShift = editSpotShift;
exports.deleteSpotShift = deleteSpotShift;
exports.getSpotShifts = getSpotShifts;
const BASE_ROUTE = "/api/v2/spot_worker";
const EMPLOYEE_ROUTE = `${BASE_ROUTE}/employee`;
const SHIFT_ROUTE = `${BASE_ROUTE}/shift`;
function buildParams(paramsObj) {
    const params = new URLSearchParams();
    Object.entries(paramsObj).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            params.set(key, String(value));
        }
    });
    return params.toString();
}
async function handleResponse(res) {
    if (!res.ok) {
        throw new Error(`API error: ${res.status}`);
    }
    return res.json();
}
// API calls
async function createEmployee(payload) {
    const body = buildParams({
        name: payload.name,
        furigana: payload.furigana,
        phone: payload.phone,
        email: payload.email,
        branchId: payload.branchId,
    });
    const res = await fetch(EMPLOYEE_ROUTE, {
        method: "POST",
        body,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
    const data = await handleResponse(res);
    return {
        id: data.id,
        email: payload.email,
        furigana: payload.furigana,
        name: payload.name,
        phone: payload.phone,
        memo: "",
        rating: 0,
        visibleInShift: true,
    };
}
async function getEmployeeList(branchId, cursor) {
    const query = buildParams({ branchId, cursor });
    const url = query ? `${EMPLOYEE_ROUTE}?${query}` : EMPLOYEE_ROUTE;
    const res = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
    return handleResponse(res);
}
async function getEmployee(id, branchId) {
    const query = buildParams({ branchId });
    const url = query ? `${EMPLOYEE_ROUTE}/${id}?${query}` : `${EMPLOYEE_ROUTE}/${id}`;
    const res = await fetch(url, {
        method: "GET",
    });
    return handleResponse(res);
}
async function updateEmployee(payload) {
    const body = buildParams({
        branchId: payload.branchId,
        name: payload.name,
        furigana: payload.furigana,
        phone: payload.phone,
        rating: payload.rating,
        memo: payload.memo,
        visibleInShift: payload.visibleInShift,
    });
    const res = await fetch(`${EMPLOYEE_ROUTE}/${payload.id}`, {
        method: "PATCH",
        body,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
    return handleResponse(res);
}
async function deleteEmployee(id) {
    const res = await fetch(`${EMPLOYEE_ROUTE}/${id}`, {
        method: "DELETE",
    });
    if (!res.ok) {
        throw new Error(`API error: ${res.status}`);
    }
}
async function updateEmployeeBranches(payload) {
    const body = buildParams({
        addBranchId: payload.addBranchId,
        removeBranchId: payload.removeBranchId,
    });
    const res = await fetch(`${EMPLOYEE_ROUTE}/${payload.id}`, {
        method: "POST",
        body,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
    if (!res.ok) {
        throw new Error(`API error: ${res.status}`);
    }
}
async function createSpotShift(payload) {
    const body = buildParams({
        roleId: payload.roleId,
        start: payload.start,
        end: payload.end,
        industry: payload.industry,
        branchId: payload.branchId,
        wage: payload.wage,
        shiftCount: payload.shiftCount,
        purpose: payload.purpose,
        contact: payload.contact,
        access: payload.access,
        details: payload.details,
    });
    const res = await fetch(SHIFT_ROUTE, {
        method: "POST",
        body,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
    return await handleResponse(res);
}
async function editSpotShift(id, payload) {
    const body = buildParams({
        roleId: payload.roleId,
        start: payload.start,
        end: payload.end,
        industry: payload.industry,
        branchId: payload.branchId,
        wage: payload.wage,
        shiftCount: payload.shiftCount,
        purpose: payload.purpose,
        contact: payload.contact,
        access: payload.access,
        details: payload.details,
    });
    const res = await fetch(SHIFT_ROUTE + `/${id}`, {
        method: "PATCH",
        body,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
    return await handleResponse(res);
}
async function deleteSpotShift(id) {
    const res = await fetch(SHIFT_ROUTE + `/${id}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
    return res.ok;
}
async function getSpotShifts(payload, cursor) {
    const params = new URLSearchParams();
    params.set("allSlots", "true");
    if (payload.branchIds?.length) {
        params.set("branchIds", payload.branchIds.join(","));
    }
    else if (payload.groupId) {
        params.set("groupId", payload.groupId.toString());
    }
    if (payload.startDate) {
        params.set("fromGte", payload.startDate.toISOString());
    }
    if (payload.endDate) {
        params.set("toLt", payload.endDate.toISOString());
    }
    if (cursor) {
        params.set("cursor", cursor);
    }
    const res = await fetch(`${SHIFT_ROUTE}?${params.toString()}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
    const out = await handleResponse(res);
    return out;
}
